// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:11:26

export default {
  "id": "speed-master",
  "slug": "speed-master",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/0e90c570e6204b699b810e08cf9b72d7-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/0e90c570e6204b699b810e08cf9b72d7/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Speed Master",
      "description": "The roar of engines, the thrill of speed, and a road that stretches into eternity. You're not just driving you're competing. Collect cash, dodge obstacles, and smash through competitors to upgrade your ride. Every hit scores points, pushing you closer to the ultimate upgrade. It's fast, furious, and utterly addictive. Your mission? To outpace, outsmart, and outlast your rivals in a high-speed quest for glory. So, buckle up and get ready to unleash the Speed Master within!",
      "instructions": "Navigate your car using either arrow keys on desktop or simply through swiping on mobile devices. Dodge obstacles in your way, collect cash and push your competitors out of the road to upgrade your car and reach the highest score possible!",
      "genres": [
        "Racing & Driving"
      ],
      "tags": [
        "arcade",
        "car",
        "highscore",
        "skill",
        "speed"
      ]
    },
    "zh-CN": {
      "title": "速度大师",
      "description": "引擎的咆哮，速度的快感，一条延伸至尽头的道路。你不仅仅是在驾驶，你是在竞争。收集现金，躲避障碍，撞倒对手以升级你的座驾。每一次撞击都能得分，让你更接近终极升级。这游戏又快又激烈，完全上瘾。你的任务？在高速征途中超越、智胜、超越你的对手，赢得荣耀。所以，系好安全带，准备释放你体内的速度大师吧！",
      "instructions": "使用电脑上的箭头键或通过在移动设备上滑动来控制你的汽车。避开路上的障碍物，收集现金，推挤对手出车道，升级你的汽车，争取获得最高分！",
      "genres": [
        "赛车与驾驶"
      ],
      "tags": [
        "街机",
        "汽车",
        "高分",
        "技巧",
        "速度"
      ]
    },
    "zh-TW": {
      "title": "速度大師",
      "description": "引擎的咆哮聲，速度的刺激感，以及一條延伸至永恆的道路。你並不只是在駕駛，你是在競爭。收集現金，避開障礙，擊敗對手以升級你的愛車。每一次擊中都能得分，讓你更接近最終升級。這是快速的、瘋狂的、完全上癮的。你的任務？在高速尋求榮耀的征途中，超越、智勝並超越你的對手。所以，綁緊安全帶，準備發揮你內在的速度之主！",
      "instructions": "使用桌面上的方向鍵或僅僅通過在行動裝置上滑動來駕馭你的車輛。擋開路障，收集現金，將競爭對手推出道路以升級你的車輛並達到最高的分數！",
      "genres": [
        "賽車與駕駛"
      ],
      "tags": [
        "電子遊戲機",
        "車輛",
        "最高分",
        "技能",
        "速度"
      ]
    },
    "zh-HK": {
      "title": "速度大師",
      "description": "引擎的咆哮聲，速度的刺激，以及無盡的公路。你並非只是駕駛，而是在競賽。收集現金，躲避障礙，擊敗對手來升級你的愛車。每一次擊中都能得分，讓你更接近最終升級。這是快速、瘋狂且絕對上癮。你的任務？在高速尋求榮耀的征途中，超越、智勝並超越你的對手。所以，緊緊扣好安全帶，準備釋放內在的速霸者吧！",
      "instructions": "用桌面上的方向鍵或單純在移動裝置上掃描來駕馭你的車。避開路邊的障礙物，收集現金，推開對手，升級你的車輛，並達到可能的最高分！",
      "genres": [
        "賽車及駕駛"
      ],
      "tags": [
        "電子遊戲中心",
        "汽車",
        "高分",
        "技術",
        "速度"
      ]
    },
    "ja": {
      "title": "スピードマスター",
      "description": "エンジンの roar、スピードの thrill、永遠に続く道。あなたはただ運転しているのではなく、競争しているのだ。お金を集め、障害物を避け、競合相手を潰して乗り物をアップグレードしよう。どんなヒットもポイントが入る、そしてあなたを最終的なアップグレードに近づける。速くて、激しくて、完全に中毒性だ。あなたのミッションは、栄誉の高速クエストでライバルを追い越え、賢く、長持ちさせることだ。さあ、ハーネスを締め、スピードマスターの内なる力を解き放ちよう！",
      "instructions": "デスクトップでは矢印キーを使用して、モバイルデバイスではスワイプで車を操作してください。道の障害物を避け、お金を集め、競合相手を道から追い出して、車をアップグレードし、最高得点を目指してください！",
      "genres": [
        "レース & ドライビング"
      ],
      "tags": [
        "アーケード",
        "車",
        "ハイスコア",
        "スキル",
        "スピード"
      ]
    },
    "ko": {
      "title": "스피드 마스터",
      "description": "엔진의 울부짖음, 속도의 즐거움, 영원까지 이어지는 도로. 이제 단순히 운전하는 것이 아니라 경쟁을 하고 있습니다. 현금을 모으고 장애물을 피하고 경쟁자를 망가뜨려 자동차를 업그레이드하세요. 모든 타격은 포인트를 기록하며, 최종 업그레이드에 가까워지게 합니다. 빠르고, 열정적이고, 전적으로 중독성이 있습니다. 여러분의 임무는 명예의 고속 경쟁에서 라이벌을 제쳐버리는 것입니다. 따라서 안전락을 채우고 속도 마스터 안에 있는 자신을 발산할 준비를 하세요!",
      "instructions": "데스크톱에서는 아로라키 키를 사용하여, 모바일 기기에서는 간단히 슬라이딩으로 자동차를 이동하세요. 길에 있는 장애물을 피하고 돈을 모으고, 경쟁자를 도로에서 밀어내어 자동차를 업그레이드하고 가장 높은 점수를 달성하세요!",
      "genres": [
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "어케이드",
        "카",
        "하이스코어",
        "기술",
        "속도"
      ]
    },
    "fr": {
      "title": "Maître de la Vitesse",
      "description": "Le rugissement des moteurs, le frisson de la vitesse et une route qui s'étend à l'infini. Vous ne conduisez pas, vous compitez. Ramassez de l'argent, évitez les obstacles et écrasez vos concurrents pour améliorer votre véhicule. Chaque coup porté rapporte des points, vous rapprochant de la mise à niveau ultime. C'est rapide, furieux et complètement addictif. Votre mission ? Dépasser, déjouer et surpasser vos rivaux dans une quête à haute vitesse pour la gloire. Mettez-vous en ceinture et préparez-vous à libérer le Maître de la Vitesse qui est en vous !",
      "instructions": "Naviguez votre voiture en utilisant les touches fléchées sur le bureau ou simplement en glissant sur les appareils mobiles. Évitez les obstacles sur votre chemin, collectez de l'argent et éliminez vos concurrents de la route pour améliorer votre voiture et atteindre le score le plus élevé possible !",
      "genres": [
        "Course et conduite"
      ],
      "tags": [
        "arcade",
        "voiture",
        "record最高分",
        "compétence",
        "vitesse"
      ]
    }
  }
};
